import { render, staticRenderFns } from "./Troubleshoot.vue?vue&type=template&id=fc0bc0f6&scoped=true&"
import script from "./Troubleshoot.vue?vue&type=script&lang=js&"
export * from "./Troubleshoot.vue?vue&type=script&lang=js&"
import style0 from "./Troubleshoot.vue?vue&type=style&index=0&id=fc0bc0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0bc0f6",
  null
  
)

export default component.exports